import React from 'react';
import { PuzzlePieceIcon } from '@heroicons/react/24/outline';
import { Button } from '@plerionhq/design-system';
import { useNavigate } from 'react-router-dom';
import { ProtectedComponent } from '../components/shared/ProtectedComponent/ProtectedComponent';

import { useTranslation } from 'react-i18next';

export const AddCloudIntegration = () => {
  const { t } = useTranslation('containerInterface');
  const navigate = useNavigate();

  return (
    <div className="flex flex-row items-center gap-2">
      <div className="flex-shrink-0 self-center rounded-lg p-2">
        <PuzzlePieceIcon className="h-8 w-8" />
      </div>
      <div className="flex justify-center">
        <p className="text-darkest-gray my-2 text-base font-semibold">
          {t('connectYourCloudProviderToGetStarted')}
        </p>
      </div>
      <ProtectedComponent permission="integration:Administration">
        <div className="ml-auto flex-shrink-0 items-center">
          <Button
            variant="primary"
            label={t('common:addIntegration')}
            onClick={() => navigate('/settings/integrations')}
            size="small"
          />
        </div>
      </ProtectedComponent>
    </div>
  );
};
